import { reject } from 'lodash'

import i18n from '@/i18n/i18n'
import { BrandService } from '@/services/admin/BrandService'
import { build_query, errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const allowedFilters = ['name', 'id']
export const allowedIncludes = []
export const allowedSorts = '-id'

export const state = {
  brands: [],
  brand: {},
  meta: null,
  brandCategories: [],
  results: [],
  resultsMeta: null
}

export const mutations = {
  SET_BRANDS(state, brands) {
    state.brands = brands.data
    state.meta = brands.meta
  },
  SET_BRAND(state, brand) {
    state.brand = brand
  },
  ADD_BRAND(state, brand) {
    state.brands.unshift(brand)
  },
  DELETE_BRAND(state, brandsToRemove) {
    state.brands = state.brands.filter(brand => {
      return brand.id !== brandsToRemove.id
    })
  },
  SET_CATEGORIES(state, categories) {
    state.brandCategories = categories
  },
  SET_RESULTS(state, results) {
    state.results = results.data
    state.resultsMeta = results.meta
  }
}

export const actions = {
  getBrands({ commit }, query) {
    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts)
    return new Promise(resolve => {
      let brandService = new BrandService(newQuery)
      brandService.getBrands().then(response => {
        commit('SET_BRANDS', response)
        resolve(response)
      })
    })
  },
  getBrandsByCategory({ dispatch }, categoryId) {
    return new Promise((resolve, reject) => {
      let brandService = new BrandService()
      brandService
        .getBrandsByCategory(categoryId)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.brands.brands')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getBrand({ commit }, id) {
    return new Promise(resolve => {
      let brandService = new BrandService()
      brandService.getBrand(id).then(response => {
        commit('SET_BRAND', response.data)
        resolve(response.data)
      })
    })
  },
  getBrandCategories({ commit }, id) {
    return new Promise((resolve, reject) => {
      let brandService = new BrandService()
      brandService.getBrandCategories(id).then(response => {
        commit('SET_CATEGORIES', response.data)
        resolve(response.data)
      })
    })
  },
  createBrand({ commit, dispatch }, params) {
    return new Promise(resolve => {
      let brandService = new BrandService()
      brandService
        .createBrand(params.brand, params.categories)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.added', {
              element: t('store.admin.brands.brand')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          commit('ADD_BRAND', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.adding_problem', {
                element: t('store.admin.brands.brand')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateBrand({ state, dispatch }, params) {
    return new Promise((resolve, reject) => {
      let brandService = new BrandService()
      brandService
        .updateBrand(params.brand.id, params.brand.name, params.categories)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('store.admin.brands.brand')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.update_error', {
                element: t('store.admin.brands.brand')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  destroyBrand({ commit, dispatch }, brand) {
    return new Promise(resolve => {
      let brandService = new BrandService()
      brandService
        .destroyBrand(brand.id)
        .then(response => {
          commit('DELETE_BRAND', brand)
          const notification = {
            type: 'warning',
            message: t('store.shared.deleted', {
              element: t('store.admin.brands.brand')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.not_deleted', {
                element: t('store.admin.brands.brand')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  search({ state, commit, dispatch }, brand) {
    return new Promise((resolve, reject) => {
      if (brand === '') {
        commit('SET_RESULTS', { data: [], meta: {} })
        resolve(state.results)
      } else {
        let brandService = new BrandService()
        brandService
          .searchBrand(brand)
          .then(response => {
            commit('SET_RESULTS', response)
            resolve(response.data)
          })
          .catch(err => {
            const notification = {
              type: 'danger',
              message:
                t('store.shared.search_error', {
                  element: t('store.admin.brands.brand')
                }) + errorMessage(err)
            }
            dispatch('notification/add', notification, {
              root: true
            })
            reject(err)
          })
      }
    })
  }
}
